import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Chip from "@material-ui/core/Chip";
import { ADDRESS_MATCH_OPTIONS, QUOTE_MATCH_OPTIONS } from './constants';

class CarrierInvoiceDetailFiltersDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

renderAutocomplete({ label, filterKey, options, openKey }) {
        const { filtersMap, onChange } = this.props;

        return (
            <Autocomplete
                multiple
                open={this.state[openKey]}
                value={filtersMap?.[filterKey] ?? []}
                options={options}
                disableCloseOnSelect
                getOptionLabel={(option) => option}
                renderTags={(value) =>
                    value.map((option) => (
                        <Chip
                            key={option}
                            variant="outlined"
                            size="small"
                            style={{ borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px" }}
                            label={option}
                        />
                    ))
                }
                renderOption={(option, { selected }) => (
                    <React.Fragment>
                        <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option}
                    </React.Fragment>
                )}
                onOpen={() => this.setState({ [openKey]: true })}
                onClose={(_, reason) =>
                    this.setState({ [openKey]: reason === 'blur' ? false : true })
                }
                onChange={(_, value) => onChange(filterKey, value)}
                style={{ width: 350, margin: 10, marginBottom: 20 }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                    />
                )}
            />
        );
    }


    render() {
        return (
            <>
                <div>
                    <DialogTitle id="form-dialog-title" style={{ width: "70%", display: "flex", justifyContent: "center" }}>
                        Filters
                    </DialogTitle>
                    <DialogContent className={"dialogBox"}>

                        {this.renderAutocomplete({
                            label:     'Address Match',
                            filterKey: 'addressMatch',
                            options:   ADDRESS_MATCH_OPTIONS,
                            openKey:   'openAddress',
                        })}

                        {this.renderAutocomplete({
                            label:     'Quote Rate Match',
                            filterKey: 'quoteRateMatch',
                            options:   QUOTE_MATCH_OPTIONS,
                            openKey:   'openQuote',
                        })}
                    </DialogContent>

                    <DialogActions style={{ justifyContent: "center", marginBottom: 10 }}>
                        <Button variant='contained' onClick={() => this.props.onClose(false, true)}>Cancel</Button>
                        <Button variant='contained' onClick={() => {
                            this.props.onClose(true, true)
                        }} color="primary">Apply</Button>
                    </DialogActions>

                </div>
            </>
        )
    }
}

export default CarrierInvoiceDetailFiltersDialog;